import { render, staticRenderFns } from "./edit-question.vue?vue&type=template&id=4663840e&scoped=true&"
import script from "./edit-question.vue?vue&type=script&lang=js&"
export * from "./edit-question.vue?vue&type=script&lang=js&"
import style0 from "./edit-question.vue?vue&type=style&index=0&id=4663840e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4663840e",
  null
  
)

export default component.exports